<template>
  <!-- 关注我们 -->
  <section class="follow">
    <div id="follow" class="l-center">
      <div class="follow-link">
        <a data-type="facebook" title="facebook" :href="links.facebook"></a>
        <a data-type="discord" title="discord" :href="links.discord"></a>
        <a data-type="twitter" title="twitter" :href="links.twitter"></a>
        <a data-type="instagram" title="instagram" :href="links.instagram"></a>
        <a data-type="yutube" title="yutube" :href="links.youtube"></a>
        <a data-type="reddit" title="reddit" :href="links.reddit"></a>
        <!-- <a data-type="tiktok" title="tiktok" :href="links.tiktok"></a> -->
      </div>
    </div>
  </section>
</template>

<script>
import cfgData from "scripts/constants/configData";

export default {
  name: "Follow",
  data() {
    return {
      links: cfgData.links,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less">
.follow {
  @top: 900px;

  display: flex;
  align-items: center;
  margin-top: -1 * @top;
  padding-top: @top;
  height: 120px + @top;
  background-color: #f2efe8;

  .l-center {
    width: 100%;
    background-color: #ece4d6;
  }

  &-link {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    width: 722px;
    height: 120px;

    a {
      width: 60px;
      height: 60px;
      background: #e4d1b3 no-repeat center center;
      background-size: auto 50%;
      background-clip: content-box;
      border-radius: 50%;

      &:hover {
        transform: scale(1.1, 1.1);
      }
    }
  }

  [data-type="facebook"] {
    background-image: url(~images/follow/facebook.png);
  }

  [data-type="discord"] {
    background-image: url(~images/follow/discord.png);
  }

  [data-type="twitter"] {
    background-image: url(~images/follow/twitter.png);
  }

  [data-type="instagram"] {
    background-image: url(~images/follow/instagram.png);
  }

  [data-type="yutube"] {
    background-image: url(~images/follow/yutube.png);
  }

  [data-type="reddit"] {
    background-image: url(~images/follow/reddit.png);
  }

  [data-type="tiktok"] {
    background-image: url(~images/follow/tiktok.png);
  }
}
</style>
